.cz{border:1px solid #ddd;}